module.exports = __webpack_public_path__ + "static/img/SensorHost logo_transparent.3132b768.webp";